var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (groups, linkToPartnerArtist, undefined) {
buf.push("<div class=\"partner2-artists-list\"><div class=\"artists-groups-container\">");
// iterate groups
;(function(){
  var $$obj = groups;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var group = $$obj[$index];

buf.push("<nav" + (jade.cls(["artists-group artists-group-" + (group.cols.length) + "-columns"], [true])) + "><h2 class=\"avant-garde-header-center artists-group-label\">" + (jade.escape(null == (jade_interp = group.label) ? "" : jade_interp)) + "</h2><div class=\"artists-columns-container\">");
// iterate group.cols
;(function(){
  var $$obj = group.cols;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var col = $$obj[$index];

buf.push("<ul class=\"artists-column\">");
// iterate col
;(function(){
  var $$obj = col;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var pa = $$obj[$index];

if ( linkToPartnerArtist && pa.get('published_artworks_count') > 0)
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><a" + (jade.attr("href", pa.href(), true, true)) + " class=\"partner2-route-link\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</a></li>");
}
else if ( !linkToPartnerArtist)
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><a" + (jade.attr("href", "/artist/" + (pa.get('artist').id) + "", true, true)) + ">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</a></li>");
}
else
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><span class=\"artist-name\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</span></li>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var pa = $$obj[$index];

if ( linkToPartnerArtist && pa.get('published_artworks_count') > 0)
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><a" + (jade.attr("href", pa.href(), true, true)) + " class=\"partner2-route-link\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</a></li>");
}
else if ( !linkToPartnerArtist)
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><a" + (jade.attr("href", "/artist/" + (pa.get('artist').id) + "", true, true)) + ">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</a></li>");
}
else
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><span class=\"artist-name\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</span></li>");
}
    }

  }
}).call(this);

buf.push("</ul>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var col = $$obj[$index];

buf.push("<ul class=\"artists-column\">");
// iterate col
;(function(){
  var $$obj = col;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var pa = $$obj[$index];

if ( linkToPartnerArtist && pa.get('published_artworks_count') > 0)
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><a" + (jade.attr("href", pa.href(), true, true)) + " class=\"partner2-route-link\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</a></li>");
}
else if ( !linkToPartnerArtist)
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><a" + (jade.attr("href", "/artist/" + (pa.get('artist').id) + "", true, true)) + ">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</a></li>");
}
else
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><span class=\"artist-name\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</span></li>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var pa = $$obj[$index];

if ( linkToPartnerArtist && pa.get('published_artworks_count') > 0)
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><a" + (jade.attr("href", pa.href(), true, true)) + " class=\"partner2-route-link\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</a></li>");
}
else if ( !linkToPartnerArtist)
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><a" + (jade.attr("href", "/artist/" + (pa.get('artist').id) + "", true, true)) + ">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</a></li>");
}
else
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><span class=\"artist-name\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</span></li>");
}
    }

  }
}).call(this);

buf.push("</ul>");
    }

  }
}).call(this);

buf.push("</div></nav>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var group = $$obj[$index];

buf.push("<nav" + (jade.cls(["artists-group artists-group-" + (group.cols.length) + "-columns"], [true])) + "><h2 class=\"avant-garde-header-center artists-group-label\">" + (jade.escape(null == (jade_interp = group.label) ? "" : jade_interp)) + "</h2><div class=\"artists-columns-container\">");
// iterate group.cols
;(function(){
  var $$obj = group.cols;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var col = $$obj[$index];

buf.push("<ul class=\"artists-column\">");
// iterate col
;(function(){
  var $$obj = col;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var pa = $$obj[$index];

if ( linkToPartnerArtist && pa.get('published_artworks_count') > 0)
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><a" + (jade.attr("href", pa.href(), true, true)) + " class=\"partner2-route-link\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</a></li>");
}
else if ( !linkToPartnerArtist)
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><a" + (jade.attr("href", "/artist/" + (pa.get('artist').id) + "", true, true)) + ">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</a></li>");
}
else
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><span class=\"artist-name\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</span></li>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var pa = $$obj[$index];

if ( linkToPartnerArtist && pa.get('published_artworks_count') > 0)
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><a" + (jade.attr("href", pa.href(), true, true)) + " class=\"partner2-route-link\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</a></li>");
}
else if ( !linkToPartnerArtist)
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><a" + (jade.attr("href", "/artist/" + (pa.get('artist').id) + "", true, true)) + ">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</a></li>");
}
else
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><span class=\"artist-name\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</span></li>");
}
    }

  }
}).call(this);

buf.push("</ul>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var col = $$obj[$index];

buf.push("<ul class=\"artists-column\">");
// iterate col
;(function(){
  var $$obj = col;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var pa = $$obj[$index];

if ( linkToPartnerArtist && pa.get('published_artworks_count') > 0)
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><a" + (jade.attr("href", pa.href(), true, true)) + " class=\"partner2-route-link\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</a></li>");
}
else if ( !linkToPartnerArtist)
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><a" + (jade.attr("href", "/artist/" + (pa.get('artist').id) + "", true, true)) + ">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</a></li>");
}
else
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><span class=\"artist-name\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</span></li>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var pa = $$obj[$index];

if ( linkToPartnerArtist && pa.get('published_artworks_count') > 0)
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><a" + (jade.attr("href", pa.href(), true, true)) + " class=\"partner2-route-link\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</a></li>");
}
else if ( !linkToPartnerArtist)
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><a" + (jade.attr("href", "/artist/" + (pa.get('artist').id) + "", true, true)) + ">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</a></li>");
}
else
{
buf.push("<li" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + "><span class=\"artist-name\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</span></li>");
}
    }

  }
}).call(this);

buf.push("</ul>");
    }

  }
}).call(this);

buf.push("</div></nav>");
    }

  }
}).call(this);

buf.push("</div></div>");}.call(this,"groups" in locals_for_with?locals_for_with.groups:typeof groups!=="undefined"?groups:undefined,"linkToPartnerArtist" in locals_for_with?locals_for_with.linkToPartnerArtist:typeof linkToPartnerArtist!=="undefined"?linkToPartnerArtist:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;